import { render } from "./ChooseAccount.vue?vue&type=template&id=f84f5a66&scoped=true"
import script from "./ChooseAccount.vue?vue&type=script&lang=js"
export * from "./ChooseAccount.vue?vue&type=script&lang=js"

import "./ChooseAccount.vue?vue&type=style&index=0&id=f84f5a66&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src17432379/src/orprio-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f84f5a66"]])

export default __exports__